import axios from 'axios';

const namespaced = true;

const state = () => ({
  authenticated: false,
  user: {},
  permissions: ['stats'],
});

const actions = {
  CREATE_TOKEN({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/createJWT', data, {
          withCredentials: true,
        })
        .then(response => {
          commit('SET_LOGGED', true);
          resolve('success');
          if (data && typeof data.callback === 'function') {
            data.callback(response);
          }
        })
        .catch(err => {
          commit('SET_LOGGED', false);
          reject(err);
        });
    });
  },
  CHECK_TOKEN({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/checkJWT',
          {},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          commit('SET_LOGGED', true);
          if (response && response.data && response.data.data) {
            commit('SET_USER', response.data.data);
          }
          resolve(response);
        })
        .catch(err => {
          commit('SET_LOGGED', false);
          reject(err.response);
        });
    });
  },
  async login({ commit }, { username, password, callback }) {
    try {
      const { data } = await axios.post('/login', {
        username,
        password,
      });

      if (data) {
        commit('SET_USER', data);
      }

      if (typeof callback === 'function') {
        callback(data);
      }
    } catch (error) {
      if (typeof callback === 'function') {
        callback(error);
      }
    }
  },
};

const mutations = {
  SET_USER(state, data) {
    state.user = data;
  },
  SET_LOGGED(state, data) {
    state.authenticated = data;
  },
};

const getters = {
  isLogged: state => state.authenticated,
  hasPermissions(state) {
    return permissions => {
      let result = true;
      permissions.forEach(permission => {
        if (state.permissions.indexOf(permission) === -1) {
          result = false;
        }
      });
      return result;
    };
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
